import {
  AdminReportExpenseFilterInput,
  useAdminOrganizationExpensesQuery,
} from "@common/utils/graphql";
import { useMemo } from "react";

type UseReportExpensesSpendTableQueryProps = {
  filters?: AdminReportExpenseFilterInput;
  currentPage: number;
};

export const useReportExpensesSpendTableQuery = ({
  filters,
  currentPage,
}: UseReportExpensesSpendTableQueryProps) => {
  const {
    data: rawData,
    loading,
    error: graphqlError,
  } = useAdminOrganizationExpensesQuery({
    variables: {
      filters,
      pagination: {
        offset: currentPage * 10,
        pageSize: 10,
      },
    },
  });

  const expenses = useMemo(
    () =>
      rawData?.adminOrganizationExpenses.__typename ===
      "QueryAdminOrganizationExpensesSuccess"
        ? rawData.adminOrganizationExpenses.data.expenses
        : [],
    [rawData],
  );

  const hasMorePages = useMemo(() => {
    // TODO: @rushil waiting for backend to implement this
    return true;
  }, []);

  const error = useMemo(
    () =>
      !!graphqlError ||
      rawData?.adminOrganizationExpenses.__typename?.includes("Error"),
    [graphqlError, rawData],
  );

  return { expenses, loading, error, hasMorePages };
};

export type ExpenseFromReportExpensesSpendTableQuery = ReturnType<
  typeof useReportExpensesSpendTableQuery
>["expenses"][number];
